module.exports = __webpack_public_path__ + "img/grain.a87b0217.svg";